import { WorkflowConditionEnum } from "@finway-group/shared/lib/models"
import { Tag } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

interface WorkflowConditionTagInterface {
    condition?: WorkflowConditionEnum
    xMargin?: string
}

const WorkflowConditionTag: React.FC<WorkflowConditionTagInterface> = ({ condition, xMargin }) => {
    const { t } = useTranslation()

    if (!condition) return <></>

    switch (condition) {
        case WorkflowConditionEnum.OR:
        case WorkflowConditionEnum.AND:
            return <Tag className={`ant-tag ant-tag-gray pb-2 ${xMargin || "ml-8 mr-8"} mt-4`}>{t(`input:workflow.conditions.${condition}`)}</Tag>
        case WorkflowConditionEnum.IF:
            return (
                <Tag className={`ant-tag ant-tag-gray pb-2 ${xMargin || "ml-8 mr-8"} mt-4`}>
                    <span>&gt; €</span>
                </Tag>
            )
    }
}

export default React.memo(WorkflowConditionTag)
